module.exports = __webpack_public_path__ + "MaterialIcons-Regular.a37b0c01c0baf1888ca8.ttf";


//////////////////
// WEBPACK FOOTER
// C:/carlos/wks/web/vacios_web/node_modules/material-design-icons/iconfont/MaterialIcons-Regular.ttf
// module id = ../../../../material-design-icons/iconfont/MaterialIcons-Regular.ttf
// module chunks = styles